import type { Chassis, ChassisKey, Constructor, Rarity } from "../types";

function c(
  team: Constructor,
  model: string,
  rarity: Rarity,
  motor: number,
  aero: number,
): Chassis {
  return { type: "chassis", team, model, rarity, motor, aero };
}

export const CHASSIS: readonly Chassis[] = [
  // MYTHIC — statistically the most dominant cars in F1 history
  c("McLaren", "MP4/4 1988", "mythic", 95, 93),
  c("Red Bull", "RB19 2023", "mythic", 92, 98),
  c("Mercedes", "W11 2020", "mythic", 96, 97),
  c("Ferrari", "F2002 2002", "mythic", 94, 92),
  // LEGENDARY — dominant title winners
  c("Ferrari", "F2004 2004", "legend", 96, 91),
  c("Mercedes", "W07 2016", "legend", 95, 94),
  c("Williams", "FW14B 1992", "legend", 90, 96),
  c("Williams", "FW15C 1993", "legend", 91, 97),
  c("Red Bull", "RB9 2013", "legend", 89, 95),
  c("McLaren", "MCL39 2025", "legend", 93, 95),
  c("Williams", "FW18 1996", "legend", 92, 90),
  c("McLaren", "MP4/2 1984", "legend", 94, 86),
  // NORMAL — champions with shorter / more driver-dependent dominance
  c("Brawn", "BGP 001 2009", "normal", 86, 93),
  c("McLaren", "MCL38 2024", "normal", 88, 90),
  c("Red Bull", "RB6 2010", "normal", 84, 94),
  c("Renault", "R25 2005", "normal", 87, 85),
  c("Benetton", "B195 1995", "normal", 88, 83),
  c("Ferrari", "F1-2000 2000", "normal", 90, 86),
  c("Ferrari", "F2008 2008", "normal", 91, 89), // 2008 Constructors' champion
  c("Lotus", "72 1972", "normal", 83, 84),
  c("Williams", "FW07 1980", "normal", 82, 85),
];

/** Resolve a chassis by its model string. Returns undefined if missing. */
export function findChassis(model: ChassisKey): Chassis | undefined {
  return CHASSIS.find((ch) => ch.model === model);
}
